export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 5_04.e0e819ad.jpg";